import { InputAdornment, TextField } from "@mui/material";
import { isValidLthCap } from "./saveLthCap";
import { LthCapUsage } from "./LthCapUsage";

interface Props {
	value: number | null;
	onChange: (value: number | null) => void;
	disabled: boolean;
	doctorId?: number;
}

export const LthCapField = ({ value, onChange, disabled, doctorId }: Props) => (
	<TextField
		id="lth-daily-cap"
		label="Daily local telehealth cap"
		type="number"
		value={value ?? ""}
		onChange={(event) => onChange(event.target.value === "" ? null : Number(event.target.value))}
		disabled={disabled}
		inputProps={{ min: 0, max: 2147483647, step: 1 }}
		InputLabelProps={{ shrink: true }}
		InputProps={{ endAdornment: doctorId ? (
			<InputAdornment position="end">
				<LthCapUsage key={doctorId} doctorId={doctorId} dailyCap={value} />
			</InputAdornment>
		) : undefined }}
		error={!isValidLthCap(value)}
		helperText={!isValidLthCap(value)
			? "Enter a whole number of 0 or more."
			: "Leave blank for no cap"}
		sx={{ width: 240, flexShrink: 0 }}
	/>
);
